import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { DxDataGridModule } from 'devextreme-angular';
import { ConfirmBoxDirectiveModule } from 'src/app/directives';

import { ManageEmailService } from '../service/manage-email.service';
import { ManageMembersComponent } from './manage-members.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		ReactiveFormsModule,
		DxDataGridModule,
		ConfirmBoxDirectiveModule
	],	
	declarations: [ManageMembersComponent],
	exports: [ConfirmBoxDirectiveModule],
	providers: [ManageEmailService],
})
export class ManageMembersComponentModule {}
